<nav ngbNav class="navbar navbar-expand-lg navbar-light">

  <div class="container-fluid">
    <a class="navbar-brand brand-landing" href="">
      <img src="assets/img/login/Logo.png" alt="" width="100" height="100" class="d-inline-block align-text-top">
    </a>
    <button class="navbar-toggler" type="button" (click)="toggleNav()" data-toggle="collapse" data-target="#navbarNavDropdown" aria-controls="navbarNavDropdown"
    [attr.aria-expanded]="!isCollapsed" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>


    <div class="collapse navbar-collapse" id="navbarNavDropdown">

      <ul class="navbar-nav ml-auto d-flex justify-content-end align-items-end">

        <li class="nav-item active">
          <a class="nav-link" href="nav-usermanager">Home <span class="sr-only">(current)</span></a>
        </li>

        <li class="nav-item">
          <a class="nav-link" href="#">Berita</a>
        </li>

        <li class="nav-item">
          <a class="nav-link" href="#">Peraturan</a>
        </li>

        <li class="nav-item">
            <a class="nav-link" href="#">Sistem dan Prosedur</a>
        </li>

        <li class="nav-item dropdown dropdown-area" dropdown *ngIf="showMe">
          <a dropdownToggle class="nav-link dropdown-toggle" type="button" id="mega-menu" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              Aplikasi
          </a>
          <div class="dropdown-menu mega-area" aria-label="mega-menu" *dropdownMenu>
              <div class="row" style=" margin-right: -187px !important;">
                  <div class="col-md-4" *ngFor="let list of listAplikasi">
                      <h5 class="font-weight-bold">
                          <u>
                              {{list.nama}}
                          </u>
                      </h5>
                      <a class="dropdown-item" *ngFor="let listmenu of list.menu" [routerLink]="['/', list.link, listmenu.link]" style="margin-left: -10px;">
                          <button class="btn {{listmenu.icon}} fa fa-{{listmenu.icon}}" width="16" height="16" style="color: grey;"></button>
                          {{listmenu.nama}}
                          <ul style="padding-left: 50px;">
                              <div *ngFor="let submenu of listmenu.subMenu">
                                  <a class="dropdown-item" style="padding: 0;" [routerLink]="['/', list.link, listmenu.link, submenu.link]">
                                      <li style="list-style-type: none;">- {{submenu.nama}}</li>
                                  </a>
                              </div>
                          </ul>
                      </a>
                  </div>
                  <div class="col-md-4">
                      <h5 class="font-weight-bold">
                          <u>
                              Help Desk
                          </u>
                      </h5>
                      <a class="dropdown-item" href="https://drive.google.com/drive/folders/19h_C_GUpQTkTxObjqExtVkD1Cos3x9Jx" target="_blank" style="margin-left: -10px;">
                        <button class="btn fa fa fa-file-text" width="16" height="16" style="color: grey;"></button>
                        User Manual
                      </a>
                      <a class="dropdown-item" href="http://tabeldata.com/tiket" target="_blank" style="margin-left: -10px;">
                        <button class="btn fa fa fa-file-text" width="16" height="16" style="color: grey;"></button>
                        Help Desk
                      </a>
                      <a class="dropdown-item" [routerLink]="['/']" style="margin-left: -10px;">
                          <button class="btn fa fa fa-file-text" width="16" height="16" style="color: grey;"></button>
                          Video Tutorial
                      </a>
                  </div>
              </div>
          </div>
      </li>


      </ul>

    </div>

  </div>

</nav>

<div class="jumbotron jumbotron-fluid">
    <div class="container">
      <h1 class="display-4">S<span>istem</span> I<span>nformasi</span><br>
        A<span>kuntabilitas</span> P<span>endidikan</span></h1>
        <!-- <a [routerLink]="['login']" class="btn btn-warning button-login"  *ngIf=" !(loginStatus$ | async) as loginStatus ">Login</a>
        <a  class="btn btn-warning button-logout" *ngIf="(loginStatus$ | async) as loginStatus ">Logout</a> -->
        <button class="btn button-landing" (click)="click()">{{button}}</button>
    </div>
</div>

<div class="footer">
</div>
